export var ViewLayoutPlacement = /*#__PURE__*/ function(ViewLayoutPlacement) {
    ViewLayoutPlacement["VIEW_LAYOUT_PLACEMENT_UNKNOWN"] = "VIEW_LAYOUT_PLACEMENT_UNKNOWN";
    /**
   * Used when CategoryPageLayoutRequest only intend to fetch the top section of the SDUI category page
   */ ViewLayoutPlacement["TOP"] = "TOP";
    /**
   * Used when CategoryPageLayoutRequest only intend to fetch the filterable paginated section of the SDUI category page
   */ ViewLayoutPlacement["FPS"] = "FPS";
    /**
   * Used when CategoryPageLayoutRequest fetches the all sections of the SDUI category page
   */ ViewLayoutPlacement["ALL_PLACEMENTS"] = "ALL_PLACEMENTS";
    return ViewLayoutPlacement;
}({});
